var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleLogin',{attrs:{"params":_vm.googleSignInParams,"renderParams":_vm.renderParams,"onSuccess":_vm.onAuthSuccess,"onFailure":_vm.onAuthError}},[_vm._v("Continue with Google")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-236a3f00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoogleAuthBtn.vue
// module id = null
// module chunks = 